import useMainNavigationNotificationsCounter from "./useNotificationsCounter";
import useMainNavigationSupportCounters from "./useSupportCounters";
import useMainNavigationMobileFullScreen from "./useMobileFullScreen";
import useMainNavigationAnalytics from "./useAnalytics";

/**
 * Centralized hook that initializes MainNavigation functionality
 * - Counter queries (notifications, support chat, mobile behavior)
 * - Third-party integrations, analytics, etc.
 */
export const useMainNavigationInitialization = () => {
  useMainNavigationNotificationsCounter();
  useMainNavigationSupportCounters();
  useMainNavigationMobileFullScreen();
  useMainNavigationAnalytics();
};
